import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useStore } from '@store';
import { shuffle } from 'lodash';

import { faSun } from '@icons/duotone/faSun';
import { faSunBright } from '@icons/duotone/faSunBright';
import { faSunCloud } from '@icons/duotone/faSunCloud';
import { faClouds } from '@icons/duotone/faClouds';
import { faCloudFog } from '@icons/duotone/faCloudFog';
import { faCloudDrizzle } from '@icons/duotone/faCloudDrizzle';
import { faCloudShowersHeavy } from '@icons/duotone/faCloudShowersHeavy';
import { faCloudBolt } from '@icons/duotone/faCloudBolt';
import { faSnowflake } from '@icons/duotone/faSnowflake';
import { faSnowBlowing } from '@icons/duotone/faSnowBlowing';

import droneDjiPhantom3 from '@assets/images/drones/dji-phantom-3.png';
import droneDjiPhantom4 from '@assets/images/drones/dji-phantom-4.png';
import droneDjiInspire1 from '@assets/images/drones/dji-inspire-1.png';
import droneDjiInspire2 from '@assets/images/drones/dji-inspire-2.png';
import drone3DrSolo from '@assets/images/drones/3dr-solo.png';
import droneSymaX5C from '@assets/images/drones/syma-x5c.png';
import droneAutelXStar from '@assets/images/drones/autel-x-star.png';
import droneParrotBebop2 from '@assets/images/drones/parrot-bebop-2.png';
import droneDjiMavic from '@assets/images/drones/dji-mavic.png';
import droneYuneecTyphoon from '@assets/images/drones/yuneec-typhoon.png';
import droneYuneecHdRacer from '@assets/images/drones/yuneec-hd-racer.png';
import droneDjiMatrice from '@assets/images/drones/dji-matrice.png';
import droneAltaX from '@assets/images/drones/alta-x.png';
import scenarioObstacleCourse from '@assets/images/sim-scenarios/obstacle-course.png';
import scenarioCommunityPark from '@assets/images/sim-scenarios/community-park.png';
import scenarioYard from '@assets/images/sim-scenarios/yard.png';
import scenarioTutorial from '@assets/images/sim-scenarios/tutorial.png';
import scenarioBasicTraining from '@assets/images/sim-scenarios/basic-training.png';
import scenarioTheHill from '@assets/images/sim-scenarios/the-hill.png';
import scenarioParkingLot from '@assets/images/sim-scenarios/parking-lot.png';
import scenarioDroneRacing from '@assets/images/sim-scenarios/drone-racing.png';
import scenarioFlightPathPractice from '@assets/images/sim-scenarios/flight-path-practice.png';
import scenarioKidsWithDrones from '@assets/images/sim-scenarios/kids-with-drones.png';
import scenarioNistOpenLaneTest from '@assets/images/sim-scenarios/nist-open-lane-test.png';
import scenarioWarehouse from '@assets/images/sim-scenarios/warehouse.png';
import scenarioIsland from '@assets/images/sim-scenarios/island.png';
import scenarioApsa from '@assets/images/sim-scenarios/apsa.png';
import scenarioTowerInspection from '@assets/images/sim-scenarios/tower-inspection.png';
import scenarioSkipFredricksEdition from '@assets/images/sim-scenarios/skip-fredricks-edition.png';
import scenarioBridgeInspection from '@assets/images/sim-scenarios/bridge-inspection.png';

import FeatureDetailsBlock from './FeatureDetailsBlock.vue';
import FeatureRoulette, { RouletteItem } from './FeatureRoulette.vue';
import MainSectionPanel from './MainSectionPanel.vue';

/** ... */

export default /*#__PURE__*/_defineComponent({
  __name: 'MainSectionTraining',
  setup(__props) {

const droneRouletteItems: RouletteItem[] = [
  {
    id: 'phantom-3',
    title: 'Phantom 3',
    image: droneDjiPhantom3,
  },
  {
    id: 'phantom-4',
    title: 'Phantom 4',
    image: droneDjiPhantom4,
  },
  {
    id: 'inspire-1',
    title: 'Inspire 1',
    image: droneDjiInspire1,
  },
  {
    id: 'inspire-2',
    title: 'Inspire 2',
    image: droneDjiInspire2,
  },
  {
    id: '3dr-solo',
    title: '3DR Solo',
    image: drone3DrSolo,
  },
  {
    id: 'syma-x5c',
    title: 'Syma X5c',
    image: droneSymaX5C,
  },
  {
    id: 'x-star',
    title: 'X Star',
    image: droneAutelXStar,
  },
  {
    id: 'bebop-2',
    title: 'Bebop 2',
    image: droneParrotBebop2,
  },
  {
    id: 'mavic',
    title: 'Mavic',
    image: droneDjiMavic,
  },
  {
    id: 'typhoon',
    title: 'Typhoon',
    image: droneYuneecTyphoon,
  },
  {
    id: 'hd-racer',
    title: 'HD Racer',
    image: droneYuneecHdRacer,
  },
  {
    id: 'matrice',
    title: 'Matrice',
    image: droneDjiMatrice,
  },
  {
    id: 'alta-x',
    title: 'Alta X',
    image: droneAltaX,
  },
];

/** ... */
const scenarioRouletteItems: RouletteItem[] = [
  {
    id: 'obstacle-course',
    title: 'Obstacle Course',
    image: scenarioObstacleCourse,
  },
  {
    id: 'community-park',
    title: 'Community Park',
    image: scenarioCommunityPark,
  },
  {
    id: 'yard',
    title: 'Yard',
    image: scenarioYard,
  },
  {
    id: 'tutorial',
    title: 'Tutorial',
    image: scenarioTutorial,
  },
  {
    id: 'basic-training',
    title: 'Basic Training',
    image: scenarioBasicTraining,
  },
  {
    id: 'the-hill',
    title: 'The Hill',
    image: scenarioTheHill,
  },
  {
    id: 'parking-lot',
    title: 'Parking Lot',
    image: scenarioParkingLot,
  },
  {
    id: 'drone-racing',
    title: 'Drone Racing',
    image: scenarioDroneRacing,
  },
  {
    id: 'flight-path-practice',
    title: 'Flight Path Practice',
    image: scenarioFlightPathPractice,
  },
  {
    id: 'kids-with-drones',
    title: 'Kids with Drones',
    image: scenarioKidsWithDrones,
  },
  {
    id: 'nist-open-lane-test',
    title: 'NIST Open Lane Test',
    image: scenarioNistOpenLaneTest,
  },
  {
    id: 'warehouse',
    title: 'Warehouse',
    image: scenarioWarehouse,
  },
  {
    id: 'island',
    title: 'The Island',
    image: scenarioIsland,
  },
  {
    id: 'apsa',
    title: 'APSA',
    image: scenarioApsa,
  },
  {
    id: 'tower-inspection',
    title: 'Tower Inspection',
    image: scenarioTowerInspection,
  },
  {
    id: 'skip-fredricks-edition',
    title: 'Skip Fredricks Edition',
    image: scenarioSkipFredricksEdition,
  },
  {
    id: 'bridge-inspection',
    title: 'Bridge Inspection',
    image: scenarioBridgeInspection,
  },
];

/** ... */
const weatherRouletteItems: RouletteItem[] = [
  {
    id: 'clear',
    title: 'Clear',
    image: faSun,
  },
  {
    id: 'sunny',
    title: 'Sunny',
    image: faSunBright,
  },
  {
    id: 'partly-cloudy',
    title: 'Partly Cloudy',
    image: faSunCloud,
  },
  {
    id: 'mostly-cloudy',
    title: 'Mostly Cloudy',
    image: faClouds,
  },
  {
    id: 'foggy',
    title: 'Foggy',
    image: faCloudFog,
  },
  {
    id: 'light-rain',
    title: 'Light Rain',
    image: faCloudDrizzle,
  },
  {
    id: 'heavy-rain',
    title: 'Heavy Rain',
    image: faCloudShowersHeavy,
  },
  {
    id: 'thunder-storm',
    title: 'Thunder Storm',
    image: faCloudBolt,
  },
  {
    id: 'blowing-snow',
    title: 'Blowing Snow',
    image: faSnowBlowing,
  },
  {
    id: 'snowfall',
    title: 'Snowfall',
    image: faSnowflake,
  },
];

const store = useStore();

const rouletteGroups = {
  drones: shuffle(droneRouletteItems),
  scenarios: shuffle(scenarioRouletteItems),
  weather: shuffle(weatherRouletteItems),
};

/** ... */
const isMobile = computed(() => {
  return store.state.displayMode === 'mobile';
});

return { __sfc: true,droneRouletteItems, scenarioRouletteItems, weatherRouletteItems, store, rouletteGroups, isMobile, FeatureDetailsBlock, FeatureRoulette, MainSectionPanel }
}

})